export const TENANT_STORAGE_KEY = "app.tenant.current";
export const TENANT_COOKIE_KEY = "app.tenant.current";
